import React, { useState, useEffect } from "react";
import { useNavigate  } from "react-router-dom";
import { useTranslation } from "react-i18next";
import Home from "../Home";
import Breadcrumb from "../../components/Breadcrumb";
import UltmarcRemarkLabel from "../../components/UltmarcRemarkLabel";
import { Modal, Spinner } from "react-bootstrap";
import { customerRequestDetails, withdrawAffiliationRequest } from "./actions";

/*** 
@purpose : Functional component
@Parameter : {props}
**/
function AffiliationDetails() {
  const [show, setShow] = useState(false);
  const handleClose = () => setShow(false);
  const modalShow = () => setShow(true);
  const navigate = useNavigate();
  const [lang] = useTranslation("language");
  const [data, setData] = useState({});
  const [resubmit, setResubmit] = useState("");
  const [edit, setEdit] = useState("");
  const [withdraw, setWithdraw] = useState("");
  const [isLoading, setIsLoading] = useState(true);
  const [withdrawLoading, setWithdrawLoading] = useState(false);
  const [showError, setShowError] = useState(false);
  const [showWithdraw, setShowWithdraw] = useState(false);
  const [requestNotFound, setRequestNotFound] = useState();
  const routes = [
    {
      name: `${lang("Menu.home")}`,
      path: "/",
    },
    {
      name: `${lang("Menu.customerRequestStatus")}`,
      path: "/customerRequestStatus",
    },
  ];
  const withdrawRoutes = [
    {
      name: `${lang("Menu.home")}`,
      path: "/",
    },
    {
      name: `${lang("Menu.personCustomer")}`,
      path: "/personCustomer",
    },
    {
      name: `${lang("personDetails.personCustomerChangeRequest")}`,
      path: "",
    },
  ];

  useEffect(() => {
    async function fetchRequestDetails() {
      try {
        let id;
        let url = window.location.href;
        id = unescape(url).split("?reqId=")[1];
        let body = {
          id: id,
        };
        
        const response = await customerRequestDetails(body);
        if (response.success === true) {
          setData(response.data);
          setResubmit(response.canResubmit);
          setEdit(response.canEdit);
          setWithdraw(response.canWithdraw);
        } else if (
          response.success === false &&
          response.data.message === "given Request id not found"
        ) {
          setRequestNotFound(true);
        }
      } catch (error) {
        console.error("Error fetching request details:", error);
      } finally {
        setIsLoading(false);
      }
    }
    
    fetchRequestDetails();
  }, []);

  const handleCloseError = () => setShowError(false);

  /*** 
    @purpose : Change route
    @Parameter : {e, page}
    **/
  const changeRoute = (e, page) => {
    e.stopPropagation();
    e.nativeEvent.stopImmediatePropagation();
    navigate(page);
  };

  const withdrawRequest = async () => {
    try {
      setWithdrawLoading(true);
      setShow(false);
      let body = {
        id: data.submission_id.value,
      };
      
      const response = await withdrawAffiliationRequest(body);
      if (response.success === true) {
        setShowWithdraw(true);
      } else if (response.success === false) {
        setShowError(true);
      }
    } catch (error) {
      console.error("Error withdrawing affiliation request:", error);
      setShowError(true);
    } finally {
      setWithdrawLoading(false);
    }
  };

  /*** 
@purpose : Unix time stamp to YYYY-MM-DD
@Parameter : {timestamp}
**/
  const unixToYYYYMMDD = (timestamp) => {
    var a = new Date(timestamp * 1000);
    var year = a.getFullYear();
    let month = a.getMonth() + 1;
    if (month.toString().length === 1) {
      month = '0' + month
    }
    var date = a.getDate();
    var time = year + '/' + month + '/' + date;
    return time;
  };

  return (
    <Home>
      <Breadcrumb routes={showWithdraw ? withdrawRoutes : routes} />
      {!requestNotFound && showWithdraw && !withdrawLoading && (
        <div className="card shadow-card">
          <div className="card-header">
            <h4>{lang("organizationDetails.completedLabel")}</h4>
          </div>
          <div className="card-body">
            <p className="mb-2 mt-2">
              {lang("errorMessages.YOUR_REQUEST")} {data.submission_id.value}{" "}
              {lang("errorMessages.CANCELLED")}
            </p>
          </div>
        </div>
      )}
      {withdrawLoading && <Spinner animation="border" />}
      {!isLoading && !showWithdraw && !withdrawLoading && (
        <>
          <h2>{lang("customerRequestStatus.affiliationRequestStatus")}</h2>
          <div className="card shadow-card">
            <div className="card-body">
              <div className="row">
                <div className="col-md-6">
                  <div className="horizon-form2 form-group">
                    <div className="custom-3">
                      <label>
                        {lang("customerRequestStatus.submissionType")}
                      </label>
                    </div>
                    <div className="custom-9">
                      <input
                        type="text"
                        className="form-control"
                        value={
                          data && data.submission_type
                            ? data.submission_type.value
                            : ""
                        }
                        readOnly
                      />
                    </div>
                  </div>
                </div>
                <div className="col-md-6">
                  <div className="horizon-form2 form-group">
                    <div className="custom-3">
                      <label>
                        {lang("customerRequestStatus.submissionData")}
                      </label>
                    </div>
                    <div className="custom-9">
                      <input
                        type="text"
                        className="form-control"
                        value={
                          data && data.submission_data
                            ? data.submission_data.value
                            : ""
                        }
                        readOnly
                        disabled
                      />
                    </div>
                  </div>
                </div>
                <div className="col-md-6">
                  <div className="horizon-form2 form-group">
                    <div className="custom-3">
                      <label>
                        {lang("organizationDetails.unifiedCustomerCode")}
                      </label>
                    </div>
                    <div className="custom-9">
                      <input
                        type="text"
                        className="form-control"
                        value={
                          /* data && data.lagacy_unified_customer_code  /* SAKAMOTO: AHDD-5861 Ultmarc code change */
                          /*  ? data.lagacy_unified_customer_code.value /* SAKAMOTO: AHDD-5861 Ultmarc code change */
                          data && data.unified_customer_code            /* SAKAMOTO: AHDD-5861 Ultmarc code change */
                            ? data.unified_customer_code.value          /* SAKAMOTO: AHDD-5861 Ultmarc code change */
                            : ""
                        }
                        readOnly
                      />
                    </div>
                  </div>
                </div>
                <div className="col-md-6">
                  <div className="horizon-form2 form-group">
                    <div className="custom-3">
                      <label>
                        {lang("customerRequestStatus.submissionStatus")}
                      </label>
                    </div>
                    <div className="custom-9">
                      <input
                        type="text"
                        className="form-control"
                        value={
                          data && data.submission_status
                            ? data.submission_status.value
                            : ""
                        }
                        readOnly
                      />
                    </div>
                  </div>
                </div>
                <div className="col-md-6">
                  <div className="horizon-form2 form-group">
                    <div className="custom-3">
                      <label>{lang("organizationDetails.submissionID")}</label>
                    </div>
                    <div className="custom-9">
                      <input
                        type="text"
                        className="form-control"
                        value={
                          data && data.submission_id
                            ? data.submission_id.value
                            : ""
                        }
                        readOnly
                      />
                    </div>
                  </div>
                </div>
                <div className="col-md-6">
                  <div className="horizon-form2 form-group">
                    <div className="custom-3">
                      <label>{lang("organizationDetails.requesterName")}</label>
                    </div>
                    <div className="custom-9">
                      <input
                        type="text"
                        className="form-control"
                        value={
                          data && data.requester_name
                            ? data.requester_name.value
                            : ""
                        }
                        readOnly
                      />
                    </div>
                  </div>
                </div>
                <div className="col-md-6">
                  <div className="horizon-form2 form-group">
                    <div className="custom-3">
                      <label>{lang("organizationDetails.submittedDate")}</label>
                    </div>
                    <div className="custom-9">
                      <input
                        type="text"
                        className="form-control"
                        value={
                          data && data.submitted_date
                            ? unixToYYYYMMDD(data.submitted_date.value)
                            : ""
                        }
                        readOnly
                      />
                    </div>
                  </div>
                </div>
                <div className="col-md-6">
                  <div className="horizon-form2 form-group">
                    <div className="custom-3">
                      <label>{lang("organizationDetails.modifiedDate")}</label>
                    </div>
                    <div className="custom-9">
                      <input
                        type="text"
                        className="form-control"
                        value={
                          data && data.modified_date
                            ? unixToYYYYMMDD(data.modified_date.value)
                            : ""
                        }
                        readOnly
                      />
                    </div>
                  </div>
                </div>
                <div className="col-md-6">
                  <div className="horizon-form2 form-group">
                    <div className="custom-3">
                      <label>{lang("territoryDefinitionMaintenance.wwid")}</label>
                    </div>
                    <div className="custom-9">
                      <input
                        type="text"
                        className="form-control"
                        value={
                          data && data.submitted_by
                            ? data.submitted_by
                            : ""
                        }
                        readOnly
                      />
                    </div>
                  </div>
                </div>
                {data.ultmarc_reception_code &&
                  data.ultmarc_reception_code.response_from_ultmarc && (
                    <div className="col-md-6">
                      <div className="horizon-form2 form-group">
                        <div className="custom-3">
                          <label>
                            {lang(
                              "organizationDetails.reapplicationAcceptanceCode"
                            )}
                          </label>
                        </div>
                        <div className="custom-9">
                          <input
                            type="text"
                            className="form-control"
                            value={
                              data && data.ultmarc_reception_code
                                ? data.ultmarc_reception_code
                                  .response_from_ultmarc
                                : ""
                            }
                            readOnly
                          />
                        </div>
                      </div>
                    </div>
                  )}
              </div>
              <div className="buttons-group">
                <button
                  onClick={(e) => {
                    changeRoute(
                      e,
                      `/affiliationRequestResubmit?requestId=${data && data.submission_id
                        ? data.submission_id.value
                        : ""
                      }`
                    );
                  }}
                  className="btn btn-primary"
                  disabled={!resubmit}
                >
                  {lang("Buttons.resubmit")}
                </button>
                <button
                  onClick={(e) => {
                    changeRoute(
                      e,
                      `/affiliationRequestEdit?requestId=${data && data.submission_id
                        ? data.submission_id.value
                        : ""
                      }`
                    );
                  }}
                  className="btn btn-primary"
                  disabled={!edit}
                >
                  {lang("Buttons.edit")}
                </button>
                <button
                  className="btn btn-primary"
                  onClick={modalShow}
                  disabled={!withdraw}
                >
                  {lang("Buttons.withdraw")}
                </button>
              </div>
            </div>
          </div>
          <Modal
            size="sm"
            className="withdraw-modal"
            show={show}
            onHide={handleClose}
            aria-labelledby="contained-modal-title-vcenter"
            centered
          >
            <Modal.Body>
              <div className="warning-msg">
                <img src="images/warning2.svg" alt="Warning" />
                {lang("errorMessages.CANCEL_REQUEST")}{" "}
              </div>
              <div className="buttons-group">
                <button className="btn btn-primary" onClick={withdrawRequest}>
                  {lang("Buttons.ok")}
                </button>
                <button className="btn btn-primary" onClick={handleClose}>
                  {lang("Buttons.cancel")}
                </button>
              </div>
            </Modal.Body>
          </Modal>

          <div className="table-responsive simple-table">
            <table className="table" aria-describedby="table">
              <thead>
                <tr>
                  <th scope="col">{lang("customerRequestStatus.item")}</th>
                  <th scope="col">
                    {lang("customerRequestStatus.submittedValue")}
                  </th>
                  <th scope="col">
                    {lang("customerRequestStatus.responseFromUltmarc")}
                  </th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td>{lang("organizationDetails.customerType")}</td>
                  <td>
                    {data && data.customer_type ? data.customer_type.value_local ? data.customer_type.value_local : data.customer_type.value : ""}
                  </td>
                  <td>
                    {data && data.customer_type
                      ? data.customer_type.response_from_ultmarc
                      : ""}
                  </td>
                </tr>
                <tr>
                  <td>{lang("PersonMenu.kanjiName")}</td>
                  <td>
                    {data && data.name_kanji ? data.name_kanji.value : ""}
                  </td>
                  <td>
                    {data && data.name_kanji
                      ? data.name_kanji.response_from_ultmarc
                      : ""}
                  </td>
                </tr>
                <tr>
                  <td>{lang("OrganizationMenu.affiliatedName")}</td>
                  <td>
                    {data &&
                      data.affiliated_organization_customer_name &&
                      data.affiliated_organization_customer_name.value
                      ? data.affiliated_organization_customer_name.value + "(" +
                      data.affiliated_organization_customer_code.value + ")"
                      : ""}
                  </td>
                  <td>
                    {data &&
                      data.affiliated_organization_customer_name &&
                      data.affiliated_organization_customer_name
                        .response_from_ultmarc
                      ? data.affiliated_organization_customer_name
                        .response_from_ultmarc
                      : ""}
                  </td>
                </tr>
                <tr>
                  <td>{lang("organizationDetails.affiliatedDepartment")}</td>
                  <td>
                    {data && data.affiliated_department
                      ? data.affiliated_department.value
                      : ""}
                  </td>
                  <td>
                    {data && data.affiliated_department
                      ? data.affiliated_department.response_from_ultmarc
                      : ""}
                  </td>
                </tr>
                <tr>
                  <td>{lang("organizationDetails.role")}</td>
                  <td>{data && data.role ? data.role.value : ""}</td>
                  <td>
                    {data && data.role ? data.role.response_from_ultmarc : ""}
                  </td>
                </tr>
                <tr>
                  <td>{lang("organizationDetails.universityRole")}</td>
                  <td>
                    {data && data.university_role
                      ? data.university_role.value
                      : ""}
                  </td>
                  <td>
                    {data && data.university_role
                      ? data.university_role.response_from_ultmarc
                      : ""}
                  </td>
                </tr>
                <tr>
                  <td>{lang("organizationDetails.hospitalOwner")}</td>
                  <td>
                    {data && data.hospital_owner
                      ? data.hospital_owner.value
                      : ""}
                  </td>
                  <td>
                    {data && data.hospital_owner
                      ? data.hospital_owner.response_from_ultmarc
                      : ""}
                  </td>
                </tr>
                <tr>
                  <td className="remarks-label-cell">
                    <UltmarcRemarkLabel />
                  </td>
                  <td>{data && data.remarks ? data.remarks.value : ""}</td>
                  <td>
                    {data && data.remarks
                      ? data.remarks.response_from_ultmarc
                      : ""}
                  </td>
                </tr>
                {data.ultmarc_reception_code &&
                  (data.ultmarc_reception_code.value ||
                    data.ultmarc_reception_code.response_from_ultmarc) && (
                    <tr>
                      <td>
                        {lang(
                          "organizationDetails.reapplicationAcceptanceCode"
                        )}
                      </td>
                      <td>
                        {data && data.ultmarc_reception_code
                          ? data.ultmarc_reception_code.value
                          : ""}
                      </td>
                      <td>
                        {data && data.ultmarc_reception_code
                          ? data.ultmarc_reception_code.response_from_ultmarc
                          : ""}
                      </td>
                    </tr>
                  )}
              </tbody>
            </table>
          </div>
        </>
      )}
      {isLoading && <Spinner animation="border" />}
      <Modal
        size="md"
        className="withdraw-modal"
        show={requestNotFound}
        aria-labelledby="contained-modal-title-vcenter"
        centered
      >
        <Modal.Body>
          <div className="warning-msg">
            <img src="images/warning2.svg" alt="Warning" />
            {lang("errorMessages.NOT_FOUND")}{" "}
          </div>
          <p className="mb-3">
            {lang("errorMessages.SEARCH_REQUESTS")}
            <a
              className="link"
              onClick={(e) => {
                changeRoute(e, "/customerRequestStatus");
              }}
            >
              {lang("Menu.customerRequestStatus")}
            </a>
          </p>
        </Modal.Body>
      </Modal>
      <Modal
        size="sm"
        className="withdraw-modal"
        show={showError}
        onHide={handleCloseError}
        aria-labelledby="contained-modal-title-vcenter"
        centered
      >
        <Modal.Body>
          <div className="warning-msg">
            <img src="images/warning2.svg" alt="Warning" />
            {lang("errorMessages.REQUEST_NOT_SUBMITTED")}
          </div>
          <div className="buttons-group">
            <button className="btn btn-primary" onClick={handleCloseError}>
              {lang("Buttons.ok")}
            </button>
            <button className="btn btn-primary" onClick={handleCloseError}>
              {lang("Buttons.cancel")}
            </button>
          </div>
        </Modal.Body>
      </Modal>
    </Home>
  );
}

export default AffiliationDetails;